import { useMemo } from 'react'

import { RangeValue } from '../types'

interface UseYearsOfExperienceFilterProps {
  selectedYearsOfExperience: RangeValue
  onYearsOfExperienceChange: (value: RangeValue) => void
}

export const useYearsOfExperienceFilter = ({
  selectedYearsOfExperience,
  onYearsOfExperienceChange,
}: UseYearsOfExperienceFilterProps) => {
  const rangeValue = useMemo<RangeValue>(() => {
    return {
      min: 0,
      max: 30,
      gte: selectedYearsOfExperience.gte ?? null,
      lte: selectedYearsOfExperience.lte ?? null,
    }
  }, [selectedYearsOfExperience])

  return {
    rangeValue,
    onChange: onYearsOfExperienceChange,
    isLoaded: true,
  }
}
